import React from 'react';
import PropTypes from 'prop-types';

const FormField = ({htmlFor, title, children, style, required, className}) => (
  <div
    className={`form-group ${className}`}
    data-testid="formField"
    style={style}
  >
    <label
      className={`control-label col-sm-3 ${required ? 'mhd--required' : ''}`}
      htmlFor={htmlFor}
    >
      {title}
    </label>

    <div className="col-sm-9">{children}</div>
  </div>
);

FormField.defaultProps = {
  className: '',
  htmlFor: '',
  required: false,
  style: null,
  title: '',
};

FormField.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
  style: PropTypes.object,
  title: PropTypes.string,
};

export default FormField;



// WEBPACK FOOTER //
// ./src/components/Common/Form/FormField.js